import { ToastContentProps } from "react-toastify";
import { ErrorMessage } from "../ErrorMessage";

type NotifyProps = {
  message: string;
};

export function Notify({ data }: ToastContentProps<NotifyProps>) {
  return <ErrorMessage errorMessage={data.message} />;
}
